import { Controller } from "stimulus";

// Bootstrap 4 dropdowns are positioned as `position: absolute` children of
// their wrapper, so an ancestor with `overflow: auto/hidden` clips the menu.
// This controller portals the `.dropdown-menu` to `document.body` when shown
// and switches it to `position: fixed` so it escapes any scroll container.
// On hide, the menu is moved back to its original parent.
export default class extends Controller {
  connect() {
    this.toggle = this.element.querySelector('[data-toggle="dropdown"]');
    this.menu = this.element.querySelector(".dropdown-menu");
    if (!this.toggle || !this.menu) return;

    this._onShown = this.handleShown.bind(this);
    this._onHide = this.handleHide.bind(this);
    this.element.addEventListener("shown.bs.dropdown", this._onShown);
    this.element.addEventListener("hide.bs.dropdown", this._onHide);
  }

  disconnect() {
    if (this._onShown) this.element.removeEventListener("shown.bs.dropdown", this._onShown);
    if (this._onHide) this.element.removeEventListener("hide.bs.dropdown", this._onHide);
    this.restore();
  }

  handleShown() {
    if (!this.menu || this.originalParent) return;

    const toggleRect = this.toggle.getBoundingClientRect();
    const menuRect = this.menu.getBoundingClientRect();
    const isRightAligned = this.menu.classList.contains("dropdown-menu-right");

    this.originalParent = this.menu.parentElement;
    this.originalNextSibling = this.menu.nextSibling;
    this.originalStyle = this.menu.getAttribute("style");

    document.body.appendChild(this.menu);
    this.menu.style.position = "fixed";
    this.menu.style.top = `${toggleRect.bottom}px`;
    this.menu.style.left = isRightAligned
      ? `${toggleRect.right - menuRect.width}px`
      : `${toggleRect.left}px`;
    this.menu.style.transform = "";
    this.menu.style.margin = "0";
    this.menu.style.zIndex = "1080";
  }

  handleHide() {
    this.restore();
  }

  restore() {
    if (!this.menu || !this.originalParent) return;

    if (this.originalNextSibling && this.originalNextSibling.parentNode === this.originalParent) {
      this.originalParent.insertBefore(this.menu, this.originalNextSibling);
    } else {
      this.originalParent.appendChild(this.menu);
    }

    if (this.originalStyle === null) {
      this.menu.removeAttribute("style");
    } else {
      this.menu.setAttribute("style", this.originalStyle);
    }

    this.originalParent = null;
    this.originalNextSibling = null;
    this.originalStyle = undefined;
  }
}
